<template>
  <div>
    <div
      class="anm22-calendar-wrapper-calendar"
      style="min-height: 100px; font-weight: normal; font-size: 20px"
    >
      <div
        class="anm22-calendar-label"
        style="font-weight: normal; font-size: 20px"
      >
        {{ $anm22.strLang(lang, "Works", "Aziende") }}
      </div>

      <div id="matesContainer"></div>
      <span v-for="(id, i) in works" :key="'work-' + i">
        <div style="cursor: pointer" @click="(selectedWork = id), selectWork()">
          <div
            style="border-radius: 10px"
            class="cont anm22-calendar-wrapper-calendar inlinetext"
          >
            <div v-if="workSelected == id">
              <span>
                <img
                  class="cont-tick"
                  :src="$anm22.icons.getWorldIcon('check')"
                />
              </span>
            </div>
            <template v-if="$store.getters['works/get'](id)">
              <img
                class="anm22-calendar-round anm22-calendar-invite-img r"
                style="max-height: 45px; margin-left: 9px"
                :src="
                  $anm22.getObjIcon(
                    $store.getters['works/get'](id),
                    'workDefault'
                  )
                "
              />
              <span class="inline" style="font-size: 16px">{{
                $store.getters["works/get"](id).name
              }}</span>
            </template>
            <template v-else>
              <div
                class="anm22-calendar-round anm22-calendar-invite-img my-project-icon r"
                style="margin-left: 9px"
                :title="$anm22.strLang(lang, 'My events', 'I miei eventi')"
              >
                {{ user.name.substring(0, 1) }}
              </div>
              <span class="inline" style="font-size: 16px">{{
                $anm22.strLang(lang, "My events", "I miei eventi")
              }}</span>
            </template>
          </div>
        </div>
        <br />
      </span>
      <div v-if="works.length < 0">
        <br />
        {{
          $anm22.strLang(
            lang,
            "No work available",
            "Nessuna azienda disponibile"
          )
        }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    workSelected: [Number, String],
  },
  data() {
    return {
      selectedWork: null,
      contacts: [],
    };
  },
  computed: {
    ...mapState({
      lang: (state) => state.lang,
      user: (state) => state.auth.user,
    }),
    works() {
      return ["my"].concat(
        this.$store.getters["works/getAll"].map((w) => w.idWorldWork)
      );
    },
  },
  methods: {
    selectWork() {
      this.$anm22.eventBus.$emit("work-selected", this.selectedWork);
      this.$anm22.setCookie("anm22_work", this.selectedWork, Date.now() + 86400 * 30);
      this.$anm22.eventBus.$emit("wg-modal-close");
    },
  },
};
</script>

<style lang="scss" scoped>
.anm22-calendar-wrapper-calendar {
  width: 100%;
  box-sizing: border-box;
  padding: 4px;
  margin-bottom: -11px;
  background-color: #fff;
  border-bottom: none;
}
hr {
  border: 1px solid #ecf0f1;
  color: #ecf0f1;
}

.my-project-icon {
  margin-top: 9px;
  font-weight: normal;
  display: inline-block;
  background-color: #00af87;
  color: #fff;
  font-size: 16px;
  padding-top: 5px;
  line-height: 2;
  box-sizing: border-box;
  max-height: 100%;
  height: 40px;
  width: 40px;
  text-align: center;
  overflow: hidden;
  border-radius: 30px;
  vertical-align: middle;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  margin-right: 5px;
}
.cont-tick {
  position: absolute;
  display: inline-block;
  z-index: 999999;
  margin-top: -1px;
  margin-left: -33px;
  padding-top: 10px;
  max-width: 21px;
}
.anm22-calendar-round {
  width: 40px;
}
.r {
  margin-top: 9px;
  height: 40px;
}
.cont {
  padding: 21px 0 10px 65px;
  box-sizing: border-box;
  position: relative;
  font-weight: normal;
  min-height: 60px;
  line-height: 1;
  background-color: #f9f9f9;
}
.cont:hover {
  background-color: #eee;
}
.inline {
  font-weight: normal;
}

@media (max-width: 500px) {
  .my-project-icon {
    margin-top: 1px;
    padding-top: 3px;
    width: 36px;
    height: 36px;
  }
  .cont-tick {
    max-width: 19px;
  }

  .anm22-calendar-round {
    margin-top: 12px;
    height: 36px;
    width: 36px;
  }
}
</style>
